import { defineMessages } from 'react-intl';

export default defineMessages({
    buttonNewRow: {
        id: 'components.projectInformation.textualItems.button.newRow',
        defaultMessage: 'New row', // DE: Neue Zeile
    },
    placeholder: {
        id: 'components.projectInformation.textualItems.placeholder',
        defaultMessage: 'Placeholder text', // DE:
    },
});
